import React from "react";
import { Link } from "react-router-dom";
import notFoundGraphic from "components/Images/400-error.svg";

const NotFound = () => {
  return (
    <div className="error">
      <div className="error__container">
        <img
          className="error__image"
          src={notFoundGraphic}
          alt="simple illustration of a broken foot"
        />
        <div className="error__text">
          <h1>
            Sorry, we couldn&apos;t find the page you&apos;re looking for.
          </h1>
          <p>
            Unfortunately, there&apos;s a problem with the page you&apos;re
            looking for. Try browsing our extensive
            <Link to="/catalog" className="mx-1">
              course catalog
            </Link>
            , or
            <Link to="/contact-us" className="ms-1">
              contact us
            </Link>
            .
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
